import { Center } from '../Center'
import { Content } from '../Content'
import { Text } from '../Text'

export default function Quote({ quotation, color }) {
    return (
        <Center>
            <Content>
                <Text color={color} align="center" fontSize="1.5rem">
                    {quotation}
                </Text>
            </Content>
        </Center>
    )
}
